module.exports = __webpack_public_path__ + "static/media/door_right_rear.0ee5ea8f.jpg";